exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-58a64d50] {\n  position: relative;\n  z-index: 1001;\n}\n.spinner[data-v-58a64d50] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  background-color: #f8fafc;\n  z-index: 1000;\n  left: 0;\n  top: 0;\n}\n.spinner .spinner-border[data-v-58a64d50] {\n  position: relative;\n  top: 40%;\n  width: 8rem;\n  height: 8rem;\n  color: #36a8cd;\n}", ""]);

// exports
